export const gitInfo = { commitHash: "6521d93", version: "v2.0.0-54-g6521d93" };
